// extracted by mini-css-extract-plugin
export default {"tab-item":"SubMenu_tab-item__+TcL7","active":"SubMenu_active__6vHqt","container":"SubMenu_container__EI54R","item":"SubMenu_item__DguGr"};